import * as Highcharts from "highcharts";
import { Chart, ExportingButtonsOptions, ExportingOptions, LangOptions, LegendOptions, Options, PlotOptions } from "highcharts";
import { UtilidadExportXLSX } from "./utilidad-exportxlsx";
import { formatNumber, registerLocaleData } from '@angular/common';
import localeCo from '@angular/common/locales/es-CO';

registerLocaleData(localeCo, 'co-ES');

interface userOptionsExtended extends Highcharts.SeriesAbandsOptions {
    numeroDecimales: number;
    idPeriodicidad: number;
}

interface seriesExtended extends Highcharts.Series {
    processedXData: number[];
    xData: number[];
}

interface axisExtended extends Highcharts.Axis {
    max: number;
    min: number;
}

interface TimeTicksInfoObjectExtended extends Highcharts.TimeTicksInfoObject {
    unitName: string;
}

export class GraficaSerie {

    private listaColores = [
        '#003145', '#a91f11', '#739429', '#4682b4', '#e79601', '#512fc5',
        '#096731', '#ED561B', '#24534d', '#058DC7', '#096765', '#a91d7a',
        '#5e5e5e', '#3b1552', '#2a2a2a', '#962126', '#3d4a51', '#8c1fb3',
        '#b53d03', '#71c299', '#2029d0', '#000000', '#573b2a'
    ];

    public getColor(): string {
        var color = this.listaColores[this.aleatorio(0, 23)];
        return color;
    }

    private aleatorio(min: number, max: number) {
        const randomBuffer = new Uint32Array(1);
        window.crypto.getRandomValues(randomBuffer);
        let randomNumber = randomBuffer[0] / (0xffffffff + 1);
        min = Math.ceil(min);
        max = Math.floor(max);
        let numero = Math.floor(randomNumber * (max - min + 1)) + min;
        return numero;
    }

    public getLangOptions(): LangOptions {
        return {
            loading: 'Cargando...',
            noData: 'Sin datos para mostrar',
            months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
            weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
            shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
            rangeSelectorFrom: "Desde",
            rangeSelectorTo: "Hasta",
            rangeSelectorZoom: "Periodo",
            downloadPNG: 'Descargar imagen PNG',
            downloadJPEG: 'Descargar imagen JPEG',
            downloadPDF: 'Descargar imagen PDF',
            downloadSVG: 'Descargar imagen SVG',
            downloadCSV: 'Descargar datos en CSV',
            downloadXLS: 'Descargar datos en XLS',
            resetZoom: 'Restablecer zoom',
            resetZoomTitle: 'Restablecer zoom',
            thousandsSep: ".",
            decimalPoint: ',',
            viewData: 'Ver los datos en tabla',
            hideData: 'Ocultar los datos en tabla',
            viewFullscreen: 'Ver gráfico en pantalla completa',
            contextButtonTitle: 'Opciones de descarga',
            printChart: 'Imprimir',
            numericSymbolMagnitude: 1000
        };
    }

    public getExportingOptions(): ExportingOptions {
        let ue: UtilidadExportXLSX = new UtilidadExportXLSX();
        return {
            sourceHeight: 700,
            sourceWidth: 1465,
            buttons: {
                descargarButton: {
                    width: 100,
                    height: 30,
                    symbol: 'url(./assets/img/icoserankua-descarga-on.svg)',
                    symbolY: 15,
                    align: 'right',
                    verticalAlign: 'top',
                    menuItems: [
                        'downloadCSV',
                        'customMenuItem',
                        'separator',
                        'downloadPNG',
                        'downloadPDF',
                        'downloadSVG'
                    ]
                }
            },
            chartOptions: {
                legend: {
                    itemWidth: 600,
                    align: 'center',
                    verticalAlign: 'bottom',
                    layout: 'horizontal',
                    itemStyle: {
                        fontSize: "10px",
                        margin: '30px',
                        align: 'center'
                    }
                },
                credits: {
                    enabled: true,
                    position: {
                        align: "right",
                        verticalAlign: "bottom"
                    },
                    text: 'Descargado del sistema del Banco de la República ' + new Date().toLocaleString("en-GB")
                }
            },
            csv: {
                dateFormat: '%Y/%m/%d'
            },
            menuItemDefinitions: {
                customMenuItem: {
                    onclick: () => {
                        ue.exportarXLSX(this);
                    },
                    text: 'Descargar datos en XLS'
                }
            },
            url: "https://totoro.banrep.gov.co/exportacion/"
        }
    }

    public formatearFecha(fechaMilisegundos: number, periodicidad: string): string {
        var fecha = fechaMilisegundos;
        var formatoFecha = Highcharts.dateFormat('%b %e, %Y', fecha);
        if (periodicidad === 'Trimestral') {
            var quarter = Math.ceil((new Date(fecha).getMonth() + 1) / 3);
            formatoFecha = 'T' + quarter + ' de ' + new Date(fecha).getFullYear();
        } else if (periodicidad === 'Mensual') {
            formatoFecha = Highcharts.dateFormat('%b, %Y', fecha);
        } else if (periodicidad === 'Anual') {
            formatoFecha = Highcharts.dateFormat('Año %Y', fecha);
        } else if (periodicidad === 'Semestral') {
            var semester = Math.ceil((new Date(fecha).getMonth() + 1) / 6);
            formatoFecha = 'Semestre ' + semester + ' de ' + new Date(fecha).getFullYear();
        }
        return formatoFecha;
    }

    public getTituloEjeX(periodicidad: string): string {
        let titulo = 'Periodo';
        if (periodicidad === 'Trimestral') {
            titulo = titulo + '(TX de AAAA)';
        } else if (periodicidad === 'Mensual') {
            titulo = titulo + '(MMM, AAAA)';
        } else if (periodicidad === 'Anual') {
            titulo = titulo + '(AAAA)';
        } else if (periodicidad === 'Semestral') {
            titulo = titulo + '(Semestre de AAAA)';
        } else {
            titulo = titulo + '(MMM DD, AAAA)';
        }
        return titulo;
    }

    public generaTituloEjeX(listaSeriesChart: any[]) {
        let mapaPeriodicidad: Map<string, string> = new Map();
        let result: string = '';
        listaSeriesChart.forEach(s => {
            mapaPeriodicidad.set(s.idPeriodicidad, s.periodicidadNombre);
        });
        const listaPeridicidad = Array.from(mapaPeriodicidad.values());
        listaPeridicidad.forEach(p => {
            result = this.getTituloEjeX(p);
        });
        return result;
    }

    public generaTituloEjeY(listaSeriesChart: any[], seriesAxisPosition: { [key: number]: boolean }): Array<Highcharts.YAxisOptions> {
        let listaAxis: Array<Highcharts.YAxisOptions> = new Array();
        let mapaUnidad: { [key: string]: Map<string, string> } = { 'true': new Map(), 'false': new Map() };
        listaSeriesChart.forEach(s => {
            // se arma un mapa de unidades para cada eje (a la derecha y a la izquierda)
            mapaUnidad[seriesAxisPosition[s.id].toString()].set(s.unidadCorta, s.unidadCorta);
        });
        if (seriesAxisPosition) {
            const listaUnidadIzquierda = Array.from(mapaUnidad['false'].values());
            const listaUnidadDerecha = Array.from(mapaUnidad['true'].values());
            let valorUltimoreg = listaUnidadIzquierda.length - 1;
            let textoTituloEjeYIz: string = '';
            for (let index = 0; listaUnidadIzquierda.length > index; index++) {
                const u = listaUnidadIzquierda[index];

                if (valorUltimoreg === index) {
                    textoTituloEjeYIz = textoTituloEjeYIz + u + '';
                } else {
                    textoTituloEjeYIz = textoTituloEjeYIz + u + ', ';
                }
            }
            let seriesAxis = this.generarObjetoAxisInicial(textoTituloEjeYIz, '#666', false);
            listaAxis.push(seriesAxis);

            if (listaUnidadDerecha.length > 0) {
                let textoTituloEjeYDe: string = '';
                valorUltimoreg = listaUnidadDerecha.length - 1;
                for (let index = 0; listaUnidadDerecha.length > index; index++) {
                    const u = listaUnidadDerecha[index];

                    if (valorUltimoreg === index) {
                        textoTituloEjeYDe = textoTituloEjeYDe + u + '';
                    } else {
                        textoTituloEjeYDe = textoTituloEjeYDe + u + ', ';
                    }
                }
                let seriesAxis = this.generarObjetoAxisInicial(textoTituloEjeYDe, '#666', true);
                listaAxis.push(seriesAxis);
            }
        }

        return listaAxis;
    }

    public getAditionalHighchartsOptions(listaSeriesChart: any[], periodicidadPrincipal: number,
        periodicidadDescripcion: string, titulo: string, seriesAxisPosition: { [key: number]: boolean }): Options {
        let ue: UtilidadExportXLSX = new UtilidadExportXLSX();
        let gs: GraficaSerie = new GraficaSerie();
        let tituloEjeX = this.generaTituloEjeX(listaSeriesChart);
        let yAxis = this.generaTituloEjeY(listaSeriesChart, seriesAxisPosition);
        let mapaFuentes = this.getMapFromData(listaSeriesChart);
        let listaFuentesAgrupado = Array.from(mapaFuentes.keys());
        var labelFuentes = this.generaTextoFuente(listaFuentesAgrupado);
        return {
            responsive: {
                rules: [{
                    condition: {
                        minWidth: 300
                    }
                }]
            },
            chart: {
                height: 705,
                zooming: {
                    mouseWheel: {
                        enabled: false
                    },
                    type: 'xy'
                },
                marginBottom: 200,
                events: {
                    load: function () {
                        var chart = this;
                        var textoCabecera: any;
                        function updateTextoCabecera() {
                            var chartWidth = chart.chartWidth;
                            if (textoCabecera) {
                                textoCabecera.destroy(); // Elimina el texto anterior
                            }
                            textoCabecera = chart.renderer.text(labelFuentes).css({
                                fontSize: '11px',
                                fontWeight: '400',
                                align: 'left',
                                verticalAlign: 'bottom',
                                width: chartWidth - 20 // Ajusta el ancho del texto
                            }).attr({
                                padding: 20,
                                r: 30,
                                zIndex: 30
                            }).add();
                            textoCabecera.align(Highcharts.extend(textoCabecera.getBBox(), {
                                x: 3,
                                y: 620
                            }), false, 'spacingBox');
                        } 
                        // Llama a la función al cargar el gráfico
                        updateTextoCabecera();

                        // Actualiza el texto al redimensionar la ventana
                        window.addEventListener('resize', updateTextoCabecera);
                        /*var chartWidth = this.chartWidth;
                        // Adjust title based on window size                   
                        textoCabecera = chart.renderer.text(labelFuentes).css({
                            fontSize: '11px',
                            fontWeight: '400',
                            align: 'left',
                            verticalAlign: 'bottom',
                            width: chartWidth - 9
                        }).attr({
                            padding: 20,
                            r: 30,
                            zIndex: 30
                        }).add();
                        textoCabecera.align(Highcharts.extend(textoCabecera.getBBox(), {
                            x: 3,
                            y: 620
                        }), false, 'spacingBox');*/
                    }
                },
                resetZoomButton: {
                    position: {
                        x: -0,
                        y: -0
                    }
                }
            },
            title: {
                useHTML: true,
                text: '<div class="div-titulo-chart">' + titulo + '</div>',
                align: 'left'
            },
            credits: {
                enabled: false,
                text: ''
            },
            rangeSelector: {
                inputPosition: {
                    align: 'center',
                    y: 30
                },
                buttonPosition: {
                    align: 'left',
                    y: 30
                },
                buttons: [{
                    type: 'month',
                    count: 1,
                    text: '1 mes'
                }, {
                    type: 'year',
                    count: 1,
                    text: '1 año'
                }, {
                    type: 'year',
                    count: 5,
                    text: '5 años'
                }, {
                    type: 'year',
                    count: 10,
                    text: '10 años'
                }, {
                    type: 'all',
                    text: 'Todo'
                }],
                selected: 4,
                buttonTheme: {// styles for the buttons
                    fill: 'none',
                    stroke: 'none',
                    'stroke-width': 1,
                    width: '20',
                    style: {
                        color: '#003399',
                    },
                    states: {
                        hover: {
                        },
                        select: {
                            fill: '#000000',
                            style: {
                                color: '#ffffff',
                                fontWeight: 'bold'
                            }
                        }
                    }
                }
            },
            series: listaSeriesChart,
            yAxis: yAxis,
            xAxis: {
                type: 'datetime',
                ordinal: false,
                title: {
                    text: tituloEjeX,
                    margin: 20,
                    style: {
                        fontSize: '12',
                        fontWeight: '500',
                        fontFamily: 'Arial, sans-serif',
                        color: 'rgb(128, 128, 128)',
                    }
                },
                labels: {
                    rotation: -90,
                    style: {
                        fontSize: '12',
                        fontWeight: 'normal',
                        color: 'rgb(51, 51, 51)',
                        fontFamily: 'Arial,sans-serif'
                    },
                    formatter: function () {
                        return gs.formatearFecha(Number(this.value), periodicidadDescripcion);
                    },
                },
                startOnTick: true,
                tickPositioner: function () {
                    return new GraficaSerie().getTickPositionerFunction(this.series as seriesExtended[], this as axisExtended, periodicidadPrincipal);
                },
                crosshair: {
                    width: 3,
                    color: '#ccc'

                },
            },
            navigator: {
                height: 50,
                maskFill: 'rgba(0, 62, 108, 0.2)',
                handles: {
                    borderColor: '#000000',
                    height: 25
                }
            }
        }
    }

    public getTickPositionerFunction(series: seriesExtended[], axis: axisExtended, periodicidadPrincipal: number): Highcharts.AxisTickPositionsArray {
        let responsive: boolean;
        if (window.innerWidth > 1100)
            responsive = false;
        else
            responsive = true;
        
        let minDataVisible = series[0].processedXData[0];
        let incrementInMonthsOrYears = -1;
        for (let x of series) {
            if ((x as seriesExtended).processedXData[0] < minDataVisible)
                minDataVisible = (x as seriesExtended).processedXData[0];
        }
        //dia: 1, semana: 3, mes: 9, trimestre: 12, año: 18
        let unitName = 'year'; //unidades mostradas en el eje
        let tick = minDataVisible;
        let rangoVisible = axis.max - axis.min
        let incrementInMilliseconds = ((axis.max - axis.min) / 10); // en caso de no cumplir ninguna condición de más adelante, divide el eje en 10 partes iguales
        if (periodicidadPrincipal < 9 || periodicidadPrincipal === 23) {
            //Diaria o semanal
            if (rangoVisible > 788940000000) { //Mayor a 25 años
                if (responsive) {
                    incrementInMilliseconds = 4 * 365.25 * 24 * 3600 * 1000; //punto cada 4 años
                } else {
                    incrementInMilliseconds = 2 * 365.25 * 24 * 3600 * 1000; //punto cada 2 años
                }
                unitName = 'year';
            } else if (rangoVisible <= 788940000000 && rangoVisible > 378691200000) { //Menor a 25 años y mayor a 12 años
                if (responsive) {
                    incrementInMilliseconds = 4 * 365.25 * 24 * 3600 * 1000; //punto cada 4 años
                } else {
                    incrementInMilliseconds = 365.25 * 24 * 3600 * 1000; //punto cada 1 año
                }
                unitName = 'year';
            } else if (rangoVisible <= 378691200000 && rangoVisible > 157788000000) { // Menor a 12 años y mayor a 5 años
                if (responsive) {
                    incrementInMilliseconds = 2 * 365.25 * 24 * 3600 * 1000; //punto cada 2 años
                    unitName = 'year';
                } else {
                    incrementInMilliseconds = 6 * 30 * 24 * 3600 * 1000; //punto cada 6 meses
                    unitName = 'month';
                }
            } else if (rangoVisible <= 157788000000 && rangoVisible > 94672800000) { // Menor a 5 años y mayor a 3 años
                if (responsive) {
                    incrementInMilliseconds = 6 * 30 * 24 * 3600 * 1000; //punto cada 6 meses
                } else {
                    incrementInMilliseconds = 3 * 30 * 24 * 3600 * 1000; //punto cada 3 meses
                }
                unitName = 'month';
            } else if (rangoVisible <= 94672800000 && rangoVisible > 31557600000) { // Menor a 3 años y mayor a 1 año
                incrementInMilliseconds = 2 * 30 * 24 * 3600 * 1000; //punto cada 2 meses
                unitName = 'month';
            } else if (rangoVisible <= 31557600000 && rangoVisible > 15778800000) { // Menor a 1 año y mayor a 6 meses
                incrementInMilliseconds = 30 * 24 * 3600 * 1000; //punto cada 1 mes
                unitName = 'month';
            } else if (rangoVisible <= 15778800000 && rangoVisible > 2592000000) { // Menor a 6 meses y mayor a 1 mes
                if (responsive) {
                    incrementInMilliseconds = 14 * 24 * 3600 * 1000; //punto cada 14 días
                } else {
                    incrementInMilliseconds = 7 * 24 * 3600 * 1000; //punto cada 7 días
                }
                unitName = 'week';
            } else if (rangoVisible <= 2592000000 && rangoVisible > 1296000000) { // Menor a 1 mes y mayor a 15 días
                if (responsive) {
                    incrementInMilliseconds = 4 * 24 * 3600 * 1000; //punto cada 4 días
                } else {
                    incrementInMilliseconds = 2 * 24 * 3600 * 1000; //punto cada 2 días
                }
                unitName = 'day';
            } else if (rangoVisible <= 1296000000) { // Menor a 15 días
                incrementInMilliseconds = 24 * 3600 * 1000; //punto cada 1 día
                unitName = 'day';
            }
        } else if (periodicidadPrincipal === 18) {
            // Solo para el anual
            if (rangoVisible > 788940000000) { //Mayor a 25 años
                if (responsive) {
                    incrementInMonthsOrYears = 6;
                } else {
                    incrementInMonthsOrYears = 2;
                }
                unitName = 'year';
            } else if (rangoVisible <= 788940000000 && rangoVisible > 378691200000) { //Menor a 25 años y mayor a 12 años
                if (responsive) {
                    incrementInMonthsOrYears = 7;
                }
                unitName = 'year';
            } else { //Menor a 25 años 
                incrementInMonthsOrYears = 1;
                unitName = 'year';
            }
        } else if (periodicidadPrincipal === 12) {
            //Solo para el trimestral
            if (rangoVisible > 788940000000) { //Mayor a 25 años
                if (responsive) {
                    incrementInMonthsOrYears = 5;
                } else {
                    incrementInMonthsOrYears = 2;
                }
                unitName = 'year';
            } else if (rangoVisible <= 788940000000 && rangoVisible > 378691200000) { //Menor a 25 años y mayor a 12 años
                if (responsive) {
                    incrementInMonthsOrYears = 3;
                } else {
                    incrementInMonthsOrYears = 1;
                }
                unitName = 'year';
            } else if (rangoVisible <= 378691200000 && rangoVisible > 189345600000) { // Menor a 12 años y mayor a 6 años
                if (responsive) {
                    incrementInMonthsOrYears = 2;
                    unitName = 'year';
                } else {
                    incrementInMonthsOrYears = 6;
                    unitName = 'month';
                }
            } else if (rangoVisible <= 189345600000) { // Menor a 6 años
                if (responsive) {
                    incrementInMonthsOrYears = 6;
                } else {
                    incrementInMonthsOrYears = 3;
                }
                unitName = 'month';
            }
        } else if (periodicidadPrincipal === 9) {
            //Solo para el mensual
            if (rangoVisible > 788940000000) { //Mayor a 25 años
                if (responsive) {
                    incrementInMonthsOrYears = 10;
                } else {
                    incrementInMonthsOrYears = 2;
                }
                unitName = 'year';
            } else if (rangoVisible <= 788940000000 && rangoVisible > 378691200000) { //Menor a 25 años y mayor a 12 años
                if (responsive) {
                    incrementInMonthsOrYears = 10;
                } else {
                    incrementInMonthsOrYears = 1;
                }
                unitName = 'year';
            } else if (rangoVisible <= 378691200000 && rangoVisible > 157788000000) { // Menor a 12 años y mayor a 5 años
                if (responsive) {
                    incrementInMonthsOrYears = 2;
                    unitName = 'year';
                } else {
                    incrementInMonthsOrYears = 6;
                    unitName = 'month';
                }
            } else if (rangoVisible <= 157788000000 && rangoVisible > 94672800000) { // Menor a 5 años y mayor a 3 años
                if (responsive) {
                    incrementInMonthsOrYears = 1;
                    unitName = 'year';
                } else {
                    incrementInMonthsOrYears = 3;
                    unitName = 'month';
                }
            } else if (rangoVisible <= 94672800000 && rangoVisible > 63115200000) { // Menor a 3 años y mayor a 2 años
                incrementInMonthsOrYears = 2;
                unitName = 'month';
            } else if (rangoVisible <= 63115200000) { // Menor a 2 años
                incrementInMonthsOrYears = 1;
                unitName = 'month';
            }
        }
        let positions: Highcharts.AxisTickPositionsArray = new Array();
        if (axis.max !== null && axis.min !== null) {
            for (tick; tick - incrementInMilliseconds <= axis.max;) {
                let f = new Date(tick);
                f.setHours(0, 0, 0, 0);
                tick = f.getTime();
                positions.push(tick);
                if (incrementInMonthsOrYears !== -1) {
                    if (unitName === 'year')
                        f.setFullYear(f.getFullYear() + incrementInMonthsOrYears);
                    if (unitName === 'month')
                        f = addMonths(f, incrementInMonthsOrYears);
                    tick = f.getTime();
                } else {
                    tick += incrementInMilliseconds;
                }
            }
        }
        positions.info = {
            unitName: unitName,
            higherRanks: {}
        } as TimeTicksInfoObjectExtended;

        return positions;
    }

    public getTooltipOptions(): Highcharts.TooltipOptions {
        let gs: GraficaSerie = new GraficaSerie();
        return {
            positioner: function (labelWidth, labelHeight, point) {
                if (point.plotX < 550) {
                    return ({ x: point.plotX, y: 40 });
                } else {
                    return ({ x: point.plotX / 2, y: 40 });
                }
            },
            shared: true,
            split: false,
            useHTML: true,
            headerFormat: '<span></span>',
            formatter: function (this: Highcharts.TooltipFormatterContextObject) {
                let s: string = '';
                this.points!.forEach(point => {
                    let decimales: number = (point.series.userOptions as userOptionsExtended).numeroDecimales;
                    let periodicidad: number = Number((point.series.userOptions as userOptionsExtended).idPeriodicidad);
                    let descPeriodicidad = gs.getDescripcionPeriodicidad(periodicidad);
                    var symbol;
                    switch ((point.series as any).symbol) {
                        case 'circle':
                            symbol = '●';
                            break;
                        case 'diamond':
                            symbol = '♦';
                            break;
                        case 'square':
                            symbol = '■';
                            break;
                        case 'triangle':
                            symbol = '▲';
                            break;
                        case 'triangle-down':
                            symbol = '▼';
                            break;
                        default:
                            symbol = '';
                            break;
                    }
                    s += '<span style="color:' + point.series.color + '">' + symbol + ' ' + point.series.name + '</span><br/>'
                        + '<span>' + gs.formatearFecha(Number(point.x), descPeriodicidad) + ': <b>'
                        + formatNumber(Number(point.y), 'co-ES', '1.' + decimales + '-' + decimales) + '</b></span><br/>';
                });
                return s;
            },
            style: {
                zIndex: 999,
                width: 300
            }

        }
    }

    public getLegendOptions(): LegendOptions {
        return {
            enabled: true,
            floating: false,
            layout: 'horizontal',
            align: 'left',
            verticalAlign: 'top',
            alignColumns: true,
            itemStyle: {
                fontSize: "13px",
                padding: "30px"
            }
        }
    }

    public getPlotOptions(): PlotOptions {
        return {
            series: {
                dataGrouping: {
                    enabled: false,
                }
            }
        }
    }

    public generarObjetoAxisInicial(texto: string, color: string, opposite: boolean): Highcharts.YAxisOptions {
        let seriesAxis: Highcharts.YAxisOptions = {
            type: 'linear',
            title: {
                text: texto,
                style: {
                    color: color
                }
            },
            labels: {
                enabled: true,
                style: {
                    color: color
                }
            },
            id: opposite ? '1' : '0',
            showLastLabel: true,
            opposite: opposite
        }
        return seriesAxis;
    }

    public generarObjetoAxis(serie: any, showLastLabel: boolean, opposite: boolean, labelEnable: boolean, type: any, color: string): Highcharts.YAxisOptions {
        let titulo: string = '';
        if (labelEnable) {
            titulo = serie.unidadCorta;
        }
        let seriesAxis: Highcharts.YAxisOptions = {
            type: type,
            id: serie.nombre,
            title: {
                text: titulo,
                style: {
                    color: color
                }
            },
            labels: {
                enabled: labelEnable,
                style: {
                    color: color
                }
            },
            showLastLabel: showLastLabel,
            opposite: opposite
        }
        return seriesAxis;
    }

    public getMapFromData(listaSerie: Array<any>) {
        let fuenteBanco = 'Banco de la República';
        let mp = new Map;
        Object.values(listaSerie).forEach(key => {
            let fuente = key.fuente;
            let fuenteMostrar = fuente;
            if (fuenteMostrar == fuenteBanco) {
                fuenteMostrar = fuenteBanco;
            }
            mp.set(fuenteMostrar, fuenteMostrar)
        });
        return mp;
    }

    public generaTextoFuente(listaFuentesAgrupado: any[]): string {
        var lineaH = 5;
        var serieAnterior = '';
        var labelFuentes = '<span>Fuente(s): </span>';
        var i = 1;
        let tamanioFuentes = listaFuentesAgrupado.length;
        listaFuentesAgrupado.forEach((fuente) => {
            var fuenteMostrar = fuente;
            if (tamanioFuentes == i) {
                labelFuentes = labelFuentes + '<span style="color: black">' + fuenteMostrar + '</span>';
                return false;
            } else {
                labelFuentes = labelFuentes + '<span style="color: black">' + fuenteMostrar + '</span>' + ', <br/>';
            }
            lineaH = lineaH + fuenteMostrar.length;
            if (serieAnterior.length <= 0) {
                lineaH = lineaH + (fuenteMostrar.length * 4);
            } else {
                lineaH = lineaH + (serieAnterior.length * 4);
            }
            serieAnterior = fuente;
            if (lineaH >= 1000) {
                lineaH = 5;
                labelFuentes = labelFuentes + '<br/>';
            }
            i++;
        });
        return labelFuentes;
    }

    public getDescripcionPeriodicidad(id: number): string {
        if (id === 3 || id === 23) {
            return 'Semanal';
        } else if (id === 9 || id === 24) {
            return 'Mensual';
        } else if (id === 12) {
            return 'Trimestral';
        } else if (id === 1) {
            return 'Diaria';
        } else if (id === 18) {
            return 'Anual';
        } else {
            return 'Semestral';
        }
    }

}

function isLeapYear(year: number): boolean {
    return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
}

function addMonths(date: Date, quantity: number): Date {
    let daysInMonth = [31, (isLeapYear(date.getFullYear()) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    date.setDate(1);
    date.setMonth(date.getMonth() + quantity);
    date.setDate(daysInMonth[date.getMonth()]);
    return date;
}